(() => {
  "use strict";

  const headerSection = document.querySelector("#shopify-section-header");

  if (!headerSection) {
    return;
  }

  const spacer = document.createElement("div");
  spacer.className = "knb-sticky-header-spacer";
  spacer.setAttribute("aria-hidden", "true");

  headerSection.parentNode.insertBefore(
    spacer,
    headerSection.nextSibling
  );

  let originalTop = 0;
  let headerHeight = 0;
  let ticking = false;

  function measureHeader() {
    const wasSticky = headerSection.classList.contains(
      "knb-header-is-sticky"
    );

    if (wasSticky) {
      headerSection.classList.remove("knb-header-is-sticky");
      spacer.style.height = "0px";
    }

    const rect = headerSection.getBoundingClientRect();

    originalTop = rect.top + window.scrollY;
    headerHeight = headerSection.offsetHeight;

    if (wasSticky) {
      updateHeader();
    }
  }

  function updateHeader() {
    const shouldStick = window.scrollY > originalTop;

    headerSection.classList.toggle(
      "knb-header-is-sticky",
      shouldStick
    );

    spacer.style.height = shouldStick
      ? `${headerHeight}px`
      : "0px";

    document.documentElement.style.setProperty(
      "--knb-sticky-header-height",
      shouldStick ? `${headerHeight}px` : "0px"
    );

    ticking = false;
  }

  function requestUpdate() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }

  window.addEventListener("scroll", requestUpdate, {
    passive: true
  });

  window.addEventListener("resize", () => {
    window.clearTimeout(window.knbHeaderResizeTimer);

    window.knbHeaderResizeTimer = window.setTimeout(() => {
      measureHeader();
      updateHeader();
    }, 150);
  });

  document.addEventListener("shopify:section:load", () => {
    measureHeader();
    updateHeader();
  });

  measureHeader();
  updateHeader();
})();